import styles from "./Currency.module.css"
import { useState } from 'react';
import { Euro, ChevronDown, ChevronUp } from 'lucide-react';
import { PaymentMethodType } from "../../../../../types/order.types";
import { useTranslation } from "react-i18next";
/**
* Props for the CurrencyInput component.
*/ 
interface CurrencyInputProps{
    currency: PaymentMethodType | null; // Selected currency
    setCurrency: (Currency:PaymentMethodType)=>void; // Select currency handler
    className?: string // Optional classname 
}
/**
* A currency input component.
*
* @param props CurrencyInputProps
* @param {PaymentMethodType} props.currency - Selected currency
* @param {(Currency: PaymentMethodType | null) => void} props.setCurrency - Select currency handler
* @param {string} props.className - Optional classname 
* @returns TSX.Element
*/
const CurrencyInput = ({currency, setCurrency, className} : CurrencyInputProps) => {
    const { t } = useTranslation(); // Translation
    const [currencyOpen, setCurrencyOpen] = useState(true) // Currency open flag
    // Sample payment options
    const paymentMap = {
        "card":t("checkout.steps.3.inputs.payment_methods.card"),
        "card_on_delivery": t("checkout.steps.3.inputs.payment_methods.card_on_delivery"),
        "cash_on_delivery":t("checkout.steps.3.inputs.payment_methods.cash_on_delivery"),
        "invoice":t("checkout.steps.3.inputs.payment_methods.invoice")
    }
    
    return(
        <>
            { currencyOpen === false ? 
            <div className={`${styles.CurrencyInput} ${ className ? className : ""}`}>
                <div className={styles.CurrencyInputHeader}  onClick={()=> setCurrencyOpen(!currencyOpen)}>
                    {/*
                    <div className={styles.CurrencyInputHeaderIcon}>
                        <Euro/>
                    </div>
                    */}
                    <div className={styles.CurrencyInputHeaderText}>
                        <p className={styles.InputTitle}>{t("checkout.steps.3.inputs.payment")}</p>
                            <p className={styles.InputSelected}>
                                {currency && paymentMap[currency] 
                                ? paymentMap[currency] 
                                : t("checkout.steps.3.inputs.payment_unset")}
                            </p>
                    </div>
                    <div className={styles.CurrencyInputHeaderOpen}>
                        <ChevronDown/>
                    </div>
                </div>
            </div> 
            :
            <div className={`${styles.CurrencyInput} ${styles.CurrencyOpen} ${ className ? className : ""}`}>
                <div className={styles.CurrencyInputHeader}  onClick={()=> setCurrencyOpen(!currencyOpen)}>
                    {/*
                    <div className={styles.CurrencyInputHeaderIcon}>
                        <Euro/>
                    </div>
                    */}
                    <div className={styles.CurrencyInputHeaderText}>
                        <p className={styles.InputTitle}>{t("checkout.steps.3.inputs.payment")}</p>
                            <p className={styles.InputSelected}>
                                {currency && paymentMap[currency] 
                                ? paymentMap[currency] 
                                : t("checkout.steps.3.inputs.payment_unset")}
                            </p>
                    </div>
                    <div className={styles.CurrencyInputHeaderOpen}>
                        <ChevronUp/>
                    </div>
                </div>
                {/*<div className={styles.CurrencyInputWrapper} onChange={(e) => setCurrency((e.target as HTMLInputElement).value as "card" | "form" | "invoice")}></div>*/}
                <div className={styles.CurrencyInputWrapper} onChange={(e) => setCurrency((e.target as HTMLInputElement).value as "invoice")}>
                    <form className={styles.RadioForm}>
                        
                        <div className={styles.RadioGroup}>
                            <input type="radio" id="card" name="payment" value="card" checked={currency == "card"}/>
                            <label htmlFor="card">{t("checkout.steps.3.inputs.payment_methods.card_option")}</label>
                        </div>
                        <div className={styles.RadioGroup}>
                            <input type="radio" id="card_on_delivery" name="payment" value="card_on_delivery" checked={currency == "card_on_delivery"}/>
                            <label htmlFor="card_on_delivery">{t("checkout.steps.3.inputs.payment_methods.card_on_delivery_option")}</label>
                            </div>
                            
                        <div className={styles.RadioGroup}>
                            <input type="radio" id="cash_on_delivery" name="payment" value="cash_on_delivery" checked={currency == "cash_on_delivery"}/>
                            <label htmlFor="cash_on_delivery">{t("checkout.steps.3.inputs.payment_methods.cash_on_delivery_option")}</label>
                        </div>
                        
                        <div className={styles.RadioGroup}>
                            <input type="radio" id="invoice" name="payment" value="invoice" checked={currency == "invoice"}/>
                            <label htmlFor="invoice">{t("checkout.steps.3.inputs.payment_methods.invoice_option")}</label>
                        </div>
                    </form>
                </div>
            </div>
            }
        </>
    )
}

export default CurrencyInput;
